/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/** 验证邮件相关 */
import { http } from '@/services/api/http';
import { RequestOptions } from '@/services/api/types';
import type * as model from './models';

/** 验证邮件相关 发送验证邮件 */
export async function sendVerifyEmailGet(
  payload: {
    bizType?: string;
    emailRedirectExtra?: string;
    verifyEmail?: string;
    verifyEmailName?: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/auth/api/pub/email/sendVerifyEmail`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** 验证邮件相关 验证邮件 */
export async function verifyEmailGet(
  payload: {
    cs?: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<void>({
    url: `/auth/api/pub/email/verify`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}
